import useSWRMutation from 'swr/mutation';

interface TriggerInput {
  email?: string;
  sourceDetail?: string;
}

const fetcher = (_key: string, { arg }: { arg: TriggerInput }) =>
  fetch('/api/newsletter', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email: arg.email,
      email_source_detail: arg.sourceDetail,
    }),
  }).then((res) => {
    if (!res.ok) throw new Error('Newsletter subscription failed');
    return res.json();
  });

export const useEmailSignup = () => useSWRMutation('newsletter', fetcher);
